import { Poker2Model } from "../../model/Poker2Model";
import { Poker2Dialog } from "./Poker2Dialog";

import Container = createjs.Container;
import MouseEvent = createjs.MouseEvent;

export class Poker2GuestInviteFriendDialog extends Poker2Dialog {
    public static NAME: string = "Poker2GuestInviteFriendDialog";

    constructor(disp: Container) {
        super(disp);
    }
    protected init(): void {
        super.init();
    }

    protected applyProperties(): void {
        this.inviteDialog.btn_close.label = Poker2Model.languageData.getTextById("generic_btn_okay");
        this.inviteDialog.txt_title.text = Poker2Model.languageData.getTextById("dialog_guestinvite_title");
        this.inviteDialog.txt_copy.text = Poker2Model.languageData.getTextById("dialog_guestinvite_copy");
    }

    protected onClick(event: MouseEvent): void {
        super.onClick(event);
        switch (event.target) {
            case this.inviteDialog.btn_close:
                this.hide();
                break;
        }
    }

    protected get inviteDialog(): Library.PokerInterface.PokerGuestInviteFriend {
        return this.disp as Library.PokerInterface.PokerGuestInviteFriend;
    }
}
